export default __webpack_public_path__ + "static/media/display-2.e684599b.jpg";